import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React from 'react';
import classNames from 'classnames';
import { useLocation, useHistory } from "react-router-dom";
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';

export const MailLogPage = () => {

    const [todo, setTodo] = React.useState('');
    const [createdAt, setCreatedAt] = React.useState(new Date());
    const [errorMessage, setErrorMessage] = React.useState('');
    const [receiver, setReceiver] = React.useState('');
    const [status, setStatus] = React.useState(null);
    const [subject, setSubject] = React.useState('');
    const [text, setText] = React.useState('');
    const [type, setType] = React.useState(null);
    const [id, setId] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const [submitted, setSubmitted]  = React.useState(false);
    
    const toast = React.useRef();    
    const location = useLocation();
    let history = useHistory();

    const statusOption = [
        {label: 'Sent', value: 1},
        {label: 'Failed', value: 0}
    ];

    const typeOption = [
        {label: 'Text', value: 1},
        {label: 'Template', value: 2}
    ];

    React.useEffect(function() {
        setTodo(location.state.todo);
        if(location.state.todo === 'Ubah') {
            console.log(location.state.dataMailLog);
            setCreatedAt(new Date(location.state.dataMailLog.createdAt));
            setErrorMessage(location.state.dataMailLog.errorMessage);
            setReceiver(location.state.dataMailLog.receiver);
            setStatus(location.state.dataMailLog.status);
            setSubject(location.state.dataMailLog.subject);
            setText(location.state.dataMailLog.text);
            setType(location.state.dataMailLog.type);
            setId(location.state.dataMailLog.id);

        }        
      }, [location])

    const showSuccess = (message) => {
        toast.current.show({ severity: 'success', summary: 'Berhasil', detail: message, life: 3000 });
    };

    const showFailed = (msg) => {
        toast.current.show({ severity: 'error', summary: 'Failed', detail: msg, life: 3000 });
    };
    
    const showError = (message) => {
        toast.current.show({ severity: 'error', summary: 'Gagal', detail: message, life: 3000 });
    };

    async function clickSubmit(event) {
        event.preventDefault();
        setSubmitted(true);        

        if(!subject || !receiver || !text || type == null || status == null || !errorMessage || !createdAt || !id) {         
            showError('Form '+todo+' mail log tidak boleh ada yang kosong!');            
        } else {
            const requestPayload = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*' ,
                    'Authorization': 'Bearer ' +localStorage.getItem('jwt')
                },
                body: JSON.stringify({ 
                    errorMessage: errorMessage, 
                    id: id, 
                    receiver: receiver, 
                    subject: subject, 
                    text: text
                })

            }         
            setIsLoading(true);   
            const response = await fetch('https://springboot-widy-app.widyan123.site/widy-app/mail/re-sent', requestPayload);        
            const res = await response.json();
            console.log('response', res);
            if(response.status >= 200 && response.status <= 299) {
                showSuccess(res.message);
                setTimeout(() => {
                    history.push('/mails-log');
                }, 5000)
            } else if(response.status >= 400 && response.status <= 499) {
                showFailed(res.message);
            } else {
                showError(res.message);
            }
            setIsLoading(false);            
        }        
    }

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">                    
                <Toast ref={toast} />
                    <h5>{todo} Mail</h5>
                    <p>Use this page to start from scratch and place your custom content.</p>
                </div>
                <div className='card p-fluid'>
                    
                    <form onSubmit={clickSubmit}>
                    <div className="field">
                            <label htmlFor="subject">Subject</label>
                            <InputText id="subject" type="text" value={subject} onChange={(e) => setSubject(e.target.value)} className={classNames({ 'p-invalid': submitted && !subject })} />
                            {submitted && !subject && <small className="p-error">Enter your subject</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="receiver">Receiver</label>
                            <InputText id="receiver" type="text" value={receiver} onChange={(e) => setReceiver(e.target.value)} className={classNames({ 'p-invalid': submitted && !receiver })} />
                            {submitted && !receiver && <small className="p-error">Enter your receiver</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="text">Text</label>                            
                            <InputTextarea id="text" autoResize rows="7" cols="30" value={text} onChange={(e) => setText(e.target.value)} className={classNames({ 'p-invalid': submitted && !text })} />
                            {submitted && !text && <small className="p-error">Enter your text</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="type">Type</label>                            
                            <Dropdown id="type" value={type} onChange={(e) => setType(e.value)} options={typeOption} optionLabel="label" optionValue="value" placeholder="Select One" className={classNames({ 'p-invalid': submitted && type === null ? true:false })}></Dropdown>                                                        
                            {submitted && type === null ? true:false && <small className="p-error">Enter your type</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="status">Status</label>
                            <Dropdown id="status" value={status} onChange={(e) => setStatus(e.value)} options={statusOption} optionLabel="label" optionValue="value" placeholder="Select One" className={classNames({ 'p-invalid': submitted && status === null ? true:false })}></Dropdown>                                                        
                            {submitted && status === null ? true:false && <small className="p-error">Enter your status</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="errorMessage">Error Message</label>
                            <InputText id="errorMessage" type="text" value={errorMessage} onChange={(e) => setErrorMessage(e.target.value)} className={classNames({ 'p-invalid': submitted && !errorMessage })} />
                            {submitted && !errorMessage && <small className="p-error">Enter your error message</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="createdAt">Created At</label>                            
                            <Calendar monthNavigator yearNavigator yearRange="1990:2050" dateFormat="dd-mm-yy" showTime showSeconds value={createdAt} onChange={(e) => setCreatedAt(e.value)} className={classNames({ 'p-invalid': submitted && !createdAt })}></Calendar>
                            {submitted && !createdAt && <small className="p-error">Enter your created at</small>}
                        </div>                        
                        <Button label="Submit" className="p-button-success mr-2" loading={isLoading} />
                    </form>
                </div>  
            </div>
        </div>
    );
}
